import {observer} from 'mobx-react-lite';
import React from 'react';
import {EIconButton} from 'webapp-lib/Components';

import {Check, Close} from '_/assets/images';

import {StyledProgressBar} from './styles';

interface Props extends React.ProgressHTMLAttributes<HTMLProgressElement> {
  value: number;
  max?: number;
  onCancel?: () => void;
  onDone?: () => void;
  testId?: string;
  showActions?: boolean;
}

const UProgressBar = ({
  onCancel,
  onDone,
  testId,
  showActions = true,
  ...props
}: Props): React.ReactElement => {
  const isDone = props.value >= (props.max || 1);

  return (
    <StyledProgressBar className='ProgressBar'>
      <progress data-testid={testId} {...props} />
      {showActions ? (
        <EIconButton onClick={isDone ? onDone : onCancel}>
          {isDone ? (
            <Check data-testid='Icon-Check' />
          ) : (
            <Close data-testid='Icon-Close' />
          )}
        </EIconButton>
      ) : null}
    </StyledProgressBar>
  );
};

export const ProgressBar = observer(UProgressBar);
